"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var ButtonComponent = function ButtonComponent(_ref) {
  var component = _ref.component,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect;
  return (0, _preact.h)("div", {
    className: "forethought-agent__buttons"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__buttons-message",
    dangerouslySetInnerHTML: {
      __html: component.message
    }
  }), (0, _preact.h)("div", {
    className: "forethought-agent__buttons-row"
  }, component.buttons.map(function (btn) {
    return (0, _preact.h)("button", {
      key: btn.value,
      type: "button",
      className: "forethought-agent__pill",
      disabled: disabled,
      onClick: function onClick() {
        return onSelect(component.output_variable, btn.value, btn.display_name);
      }
    }, btn.display_name);
  })));
};

var _default = ButtonComponent;
exports.default = _default;